var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHomesVillasByMarriottCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2287_159919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2287_159919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4202 19.4191V8.90456H16.391L17.4149 7.30705V19.4481H16.4202V19.4191ZM7.58511 7.30705L8.60904 8.90456H8.57979V19.4481H7.58511V7.30705ZM11.6809 6.58091H13.3484L12.5293 7.88797L11.6809 6.58091ZM12.5 8.9917L14.0213 6.58091H15.25L12.5 10.9378L9.75 6.58091H10.9787L12.5 8.9917ZM12.5 13.9585L7.81915 6.58091H9.04787L12.5 12.0415L15.9521 6.58091H17.1809L12.5 13.9585ZM14.8404 11.3734L15.8351 9.77593V19.4191H14.8404V11.3734ZM10.7447 19.4191H14.2553V18.0249H10.7447V19.4191ZM10.7447 14.3361V12.3029L12.0319 14.3361H10.7447ZM14.2553 14.3361H12.9681L14.2553 12.3029V14.3361ZM14.2553 15.9046H10.7447V14.917H12.4122H12.5878H14.2553V15.9046ZM10.7447 17.473H14.2553V16.4855H10.7447V17.473ZM10.1596 11.3734V19.4191H9.16489V9.80498L10.1596 11.3734ZM7 20H18V6H7V20Z",
    fill: "#F69464"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHomesVillasByMarriottCircle);
export default __webpack_public_path__ + "static/media/IcoHomesVillasByMarriottCircle.348d8999c0f09efb373e940172a4b19d.svg";
export { ForwardRef as ReactComponent };